<!-- Contenedor principal del chat flotante -->
<div class="fixed bottom-6 right-6 z-49 flex flex-col items-end">
  <!-- Botón de chat flotante (burbuja) -->
  @if (!chatOpen) {
    <button
      (click)="toggleChat()"
      class="flex items-center justify-center w-16 h-16 rounded-full bg-yellow-500 text-white shadow-lg hover:bg-yellow-600 transition-all duration-300"
      >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-8 w-8"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
          />
      </svg>
    </button>
  }

  <!-- Ventana de chat -->
  @if (chatOpen) {
    <div
      class="w-80 sm:w-96 h-[500px] bg-white rounded-lg shadow-xl flex flex-col overflow-hidden animate-fadeIn"
      >
      <!-- Encabezado del chat -->
      <div class="bg-yellow-500 text-white p-4 flex justify-between items-center">
        <div class="flex items-center">
          <div class="bg-white rounded-full p-2 mr-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-yellow-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
            </svg>
          </div>
          <span class="font-medium">Atención al Cliente</span>
        </div>
        <button (click)="toggleChat()" class="text-white hover:text-gray-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
              />
          </svg>
        </button>
      </div>
      <!-- Área de mensajes -->
      <div class="flex-1 p-4 overflow-y-auto bg-gray-50">
        <!-- Mensaje de bienvenida si no hay mensajes -->
        @if (messages.length === 0 && showWelcome) {
          <div class="flex mb-4">
            <div
              class="w-8 h-8 rounded-full bg-yellow-500 flex items-center justify-center text-white mr-2"
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                  />
              </svg>
            </div>
            <div class="max-w-[80%]">
              <div class="bg-white rounded-lg p-3 shadow">
                <p class="text-gray-800" #messageEnd>
                  ¡Hola! Soy tu asistente virtual. ¿En qué puedo ayudarte hoy?
                </p>
              </div>
              <span class="text-xs text-gray-500 mt-1 block">{{
                currentTime
              }}</span>
              <div class="bg-white rounded-lg p-3 shadow">
                <chat-call-center-catalogo-problemas
                  (selectedProblem)="setSelectProblem($event)"
                ></chat-call-center-catalogo-problemas>
              </div>
            </div>
          </div>
        }
        <!-- Mensajes dinámicos -->
        @for (message of messages; track message) {
          <div
            class="flex mb-4"
            [ngClass]="{ 'justify-end': message.username === username }"
            >
            <!-- Avatar y mensaje para otros usuarios -->
            @if (message.username !== username) {
              <div
                class="w-8 h-8 rounded-full bg-yellow-500 flex items-center justify-center text-white mr-2"
                >
                @if (message.origin !== 'client') {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                      />
                  </svg>
                }
                @if (message.origin === 'client') {
                  <span class="font-bold">{{
                    message.username.charAt(0)
                  }}</span>
                }
              </div>
              <div class="max-w-[80%]">
                <div class="bg-white rounded-lg p-3 shadow">
                  <!-- Contenido de imagen -->
                  @if (message.content === 'img' && message.fileUrl) {
                    <div
                      class="mb-2"
                      >
                      <img
                        [src]="message.fileUrl"
                        [alt]="message.fileName || 'Imagen'"
                        class="max-w-full h-auto rounded-lg cursor-pointer"
                        (click)="openImagePreview(message.fileUrl!)"
                        loading="lazy"
                        />
                    </div>
                  }
                  <!-- Contenido de texto -->
                  @if (
                    message.content !== 'img' ||
                    (message.content === 'img' &&
                    message.message &&
                    message.message.trim())
                    ) {
                    <p
                      class="text-gray-800"
                      >
                      {{ message.message }}
                    </p>
                  }
                </div>
                <span class="text-xs text-gray-500 mt-1 block">{{
                  message.time
                }}</span>
              </div>
            }
            <!-- Mensaje del usuario actual -->
            @if (message.username === username) {
              <div class="max-w-[80%]">
                <div class="bg-yellow-500 rounded-lg p-3 text-white shadow">
                  <!-- Contenido de imagen -->
                  @if (message.content === 'img' && message.fileUrl) {
                    <div
                      class="mb-2"
                      >
                      <img
                        [src]="message.fileUrl"
                        [alt]="message.fileName || 'Imagen'"
                        class="max-w-full h-auto rounded-lg cursor-pointer"
                        (click)="openImagePreview(message.fileUrl!)"
                        loading="lazy"
                        />
                    </div>
                  }
                  <!-- Contenido de texto -->
                  @if (
                    message.content !== 'img' ||
                    (message.content === 'img' &&
                    message.message &&
                    message.message.trim())
                    ) {
                    <p
                      >
                      {{ message.message }}
                    </p>
                  }
                </div>
                <span class="text-xs text-gray-500 mt-1 block text-right">{{
                  message.time
                }}</span>
              </div>
              <div
                class="w-8 h-8 rounded-full bg-black flex items-center justify-center text-white ml-2"
                >
                <span class="font-bold">{{ username.charAt(0) }}</span>
              </div>
            }
          </div>
        }
        <!-- Indicador de typing -->
        @if (otherUserTyping) {
          <div class="flex mb-4">
            <div
              class="w-8 h-8 rounded-full bg-yellow-500 flex items-center justify-center text-white mr-2"
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                  />
              </svg>
            </div>
            <div class="max-w-[80%]">
              <div class="bg-white rounded-lg p-3 shadow">
                <div class="flex items-center space-x-1">
                  <span class="text-gray-600 text-sm">{{ typingUsername }} está escribiendo</span>
                  <div class="flex space-x-1">
                    <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 0ms"></div>
                    <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 150ms"></div>
                    <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 300ms"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Área de entrada de mensaje -->
      <div class="border-t border-gray-200 p-4">
        <!-- Preview del archivo seleccionado -->
        @if (selectedFile) {
          <div
            class="mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
            >
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-2">
                @if (!isImageFile(selectedFile)) {
                  <svg
                    class="w-6 h-6 text-yellow-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    ></path>
                  </svg>
                }
                @if (isImageFile(selectedFile) && selectedFilePreviewUrl) {
                  <img
                    [src]="selectedFilePreviewUrl"
                    class="w-12 h-12 object-cover rounded"
                    alt="Preview"
                    />
                }
                <div>
                  <p class="text-sm font-medium text-gray-900">
                    {{ selectedFile.name }}
                  </p>
                  <p class="text-xs text-gray-500">
                    {{ formatFileSize(selectedFile.size) }}
                  </p>
                </div>
              </div>
              <button
                (click)="removeSelectedFile()"
                class="text-red-500 hover:text-red-700"
                >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        }
        <!-- Barra de progreso de subida -->
        @if (isUploading) {
          <div class="mb-3">
            <div class="bg-gray-200 rounded-full h-2">
              <div
                class="bg-yellow-500 h-2 rounded-full transition-all duration-300"
                [style.width.%]="uploadProgress"
              ></div>
            </div>
            <p class="text-xs text-gray-500 mt-1">
              Subiendo archivo... {{ uploadProgress }}%
            </p>
          </div>
        }
        <div class="flex space-x-2">
          <!-- Botón de archivo -->
          <label
            [class]="checkDisabled() ? 'cursor-not-allowed bg-gray-300 text-gray-400 px-3 py-2 rounded-lg transition-colors duration-200' : 'cursor-pointer bg-gray-100 hover:bg-gray-200 text-gray-600 px-3 py-2 rounded-lg transition-colors duration-200'"
            >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              ></path>
            </svg>
            <input
              type="file"
              class="hidden"
              (change)="onFileSelected($event)"
              [disabled]="checkDisabled()"
              accept="image/*"
              />
          </label>
          <input
            type="text"
            [(ngModel)]="newMessage"
            (keyup.enter)="sendMessage()"
            (input)="onInputChange()"
          [placeholder]="
            chatEnded
              ? 'El chat ha finalizado'
              : selectedFile
              ? 'Agregar descripción (opcional)...'
              : 'Escribe tu mensaje...'
          "
            class="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
            [disabled]="checkDisabled()"
            />
          <button
            (click)="sendMessage()"
            [disabled]="checkDisabled() || (!newMessage.trim() && !selectedFile)"
            class="bg-yellow-500 hover:bg-yellow-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-4 py-2 rounded-lg transition-colors duration-200"
            >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
</div>
